window.shouldRedirectToCartPage = () => window.themeCartSettings?.addBehavior === 'page';

/**
 * Zipify OCU intercepts ATC button clicks (uses /cart/add.js) and never fires the
 * theme form submit / cart:updated path — so the header bubble stays hidden.
 * Sync the icon after any cart mutation from fetch (theme, Zipify, apps).
 */
(function installCartIconNetworkSync() {
  if (window.__cartIconFetchSyncInstalled) return;
  window.__cartIconFetchSyncInstalled = true;

  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;
  let debounceTimer = null;

  const syncHeaderCartIcon = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const count = cart.item_count || 0;
          if (typeof window.updateCartIconDirectly === 'function') {
            window.updateCartIconDirectly(count);
            return;
          }
          const cartSlide = document.querySelector('cart-slide');
          if (cartSlide && typeof cartSlide.updateCartIconCount === 'function') {
            cartSlide.updateCartIconCount(count);
          }
        })
        .catch(() => {});
    }, 150);
  };

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = originalFetch.apply(this, arguments);
    if (CART_MUTATION_RE.test(String(url))) {
      result
        .then((res) => {
          if (res && res.ok) syncHeaderCartIcon();
        })
        .catch(() => {});
    }
    return result;
  };
})();

function refreshCartJS() {
  if (document.body?.classList?.contains('template--landing-without-header')) {
    window.location.assign(window.routes?.cart_url || '/cart');
    return;
  }
  const cartSlide = document.querySelector('cart-slide');
  const openDrawer = () => {
    if (!window.shouldRedirectToCartPage() && cartSlide?.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  };

  const syncCartIcon = (count) => {
    if (typeof window.updateCartIconDirectly === 'function') {
      window.updateCartIconDirectly(count);
    } else if (cartSlide && typeof cartSlide.updateCartIconCount === 'function') {
      cartSlide.updateCartIconCount(count);
    }
  };

  if (cartSlide?.refreshCart) {
    Promise.resolve(cartSlide.refreshCart())
      .then(() => {
        const count = cartSlide.cartState?.cart?.item_count;
        if (count != null) {
          syncCartIcon(count);
          return;
        }
        return fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            syncCartIcon(cart.item_count || 0);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
          });
      })
      .catch(() => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            syncCartIcon(cart.item_count || 0);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
          })
          .catch(() => {});
      })
      .finally(openDrawer);
    return;
  }

  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      syncCartIcon(cart.item_count || 0);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
      openDrawer();
    })
    .catch(() => {});
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    if (window.shouldRedirectToCartPage()) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }
    refreshCartJS();
    if (openCart) {
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}
